// mutations.js
import * as types from './mutation-types';

export default {
    [types.FETCH_PRESSLIST](state, payload) {
        state.pressList = payload;
    },
};
